import { ReactElement, useState } from 'react';
import { IRegistrationProps } from './IRegistrationProps';
import ModalPasswordRules from '../ModalPasswordRules';
import PageTemplate from '../PageTemplate';
import PasswordForm from '../Form/Implementations/PasswordForm';
import commonStyles from '../styles';
import { createStyles } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { validatePassword } from '../Form/Validation';

interface Props extends IRegistrationProps {
  passwordValue: string;
  passwordConfirmValue: string;
  setPassword(password: string): void;
  setPasswordConfirm(password: string): void;
  submitError: string;
  loading?: boolean;
}

const RegistrationPassword = ({
  handleNext,
  loading,
  nextButtonContent,
  passwordConfirmValue,
  passwordValue,
  setPassword,
  setPasswordConfirm,
  submitError,
}: Props): ReactElement => {
  const { t } = useTranslation();
  const { link } = makeStyles((theme) => createStyles(commonStyles(theme)))();
  const [modalStatus, setModalStatus] = useState(false);
  const isPasswordValid = Boolean(!passwordValue) || validatePassword(passwordValue);
  const isConfirmValid = passwordValue === passwordConfirmValue;
  const [error, setError] = useState('');

  useEffect(() => {
    if (passwordConfirmValue && !isConfirmValid) setError(t('password.match'));
    if (passwordValue && !isPasswordValid) setError(t('password.instruction'));
    if (isPasswordValid && isConfirmValid) setError('');
    if (!passwordValue && !passwordConfirmValue) setError('');
  }, [isPasswordValid, t, passwordValue, passwordConfirmValue, isConfirmValid]);

  useEffect(() => {
    if (submitError) setError(submitError);
  }, [submitError]);

  return (
    <>
      <PageTemplate
        title={t('auth.create.password.title')}
        description={
          <>
            {t('auth.create.password.brief')}{' '}
            <a
              className={link}
              href="/"
              onClick={(e) => {
                e.preventDefault();
                setModalStatus(true);
              }}
            >
              {t('auth.create.password.requirements')}
            </a>
          </>
        }
        form={
          <PasswordForm
            passwordConfirm={passwordConfirmValue}
            password={passwordValue}
            setPassword={setPassword}
            setPasswordConfirm={setPasswordConfirm}
            isPasswordValid={isPasswordValid}
            isPasswordConfirmValid={isConfirmValid}
            error={t(error)}
          />
        }
        submitButtonContent={nextButtonContent}
        isLoading={loading}
        submit={handleNext}
        disableSubmit={Boolean(!passwordValue || error)}
      />

      <ModalPasswordRules open={modalStatus} setOpen={setModalStatus} />
    </>
  );
};

export default RegistrationPassword;
